export type {SchoolSearchFieldsetProps, School} from './SchoolSearchFieldset';
export {default} from './SchoolSearchFieldset';
